import React, { FC } from "react";

import { IOpenableIconButtonProps, IOpenableWrappedProps, OpenableIconButton } from "@/eworkitComponents";
import { OpenableWrapper } from "@/eworkitComponents";

export interface IModalIconButtonProps extends IOpenableIconButtonProps {}

export const ModalIconButton: FC<IModalIconButtonProps> = modalProps => (
  <OpenableWrapper>
    {(childProps: IOpenableWrappedProps) => <OpenableIconButton {...modalProps} {...childProps} />}
  </OpenableWrapper>
);
